import { render, staticRenderFns } from "./complaintlList.vue?vue&type=template&id=1cc32165&scoped=true"
import script from "./complaintlList.vue?vue&type=script&lang=js"
export * from "./complaintlList.vue?vue&type=script&lang=js"
import style0 from "./complaintlList.vue?vue&type=style&index=0&id=1cc32165&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc32165",
  null
  
)

export default component.exports